/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseError } from './BaseError';
import { LMSCapabilities } from './LMSCapabilities';
const MissingCookieErrorParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['lmsCapabilities', LMSCapabilities, 'lms_capabilities'],
]), BaseError);
export class MissingCookieError extends BaseError {
    static decode(input) {
        return MissingCookieErrorParser.decode(input).map(res => new MissingCookieError(res));
    }
    static unsafeDecode(input) {
        return MissingCookieError.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return MissingCookieErrorParser.encode(data);
    }
    static schema() {
        return MissingCookieErrorParser.schema();
    }
}
